// extracted by mini-css-extract-plugin
export default {"meetingLink":"ContractMeetings_meetingLink__tcSB6"};